import { render, staticRenderFns } from "./CantMain.vue?vue&type=template&id=5d6721fd&scoped=true&"
import script from "./CantMain.vue?vue&type=script&lang=js&"
export * from "./CantMain.vue?vue&type=script&lang=js&"
import style0 from "./CantMain.vue?vue&type=style&index=0&id=5d6721fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6721fd",
  null
  
)

/* custom blocks */
import block0 from "./CantMain.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports